import utils from "@/shared/utils";
import { Label } from "flowbite-react";
import React from "react"
import InputMask from "react-input-mask";

type Props = {
    label?: string,
    onChange: any,
    value: any,
    placeholder?: string
}

export default function CelularInput(props: Props) {
    const id = utils.keyElement()
    return <div>
        <div className="mb-2 block">
            <Label
                htmlFor={id}
                value={props.label ?? ''}
            />
        </div>
        <InputMask
            id={id}
            className="block w-full border disabled:cursor-not-allowed disabled:opacity-50 bg-gray-50 border-gray-300 text-gray-900 focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:border-blue-500 dark:focus:ring-blue-500 rounded-lg p-2.5 text-sm"
            mask="(99) 99999-9999"
            onChange={props.onChange}
            value={props.value} />
    </div>;
}